<template lang="pug">
content-page
	div(slot="nav")
		navigation
	div.hidden-sm-and-down(slot="sidebar")
		offers.mb-6
		ad(location="sidebar").mb-6
	.flow-left
		h1 {{contentpage.name}}
		span {{$t('page.webcams.webcam:elevation', {elevation: webcam.elevation})}}
		ws-content(:value="contentpage.content")
		v-img(:src="webcam.preview" :alt="webcam.name")
		v-alert.mt-2(type="warning" color="primary" text dense) {{$t('page.webcams.webcam:warning.text')}}
			|
			|
			v-btn.mt-2(color="primary" small outlined :href="webcam.url" target="_blank") {{$t('page.webcams.webcam:warning.button')}}
		travelbox.mb-6(v-if="webcam.nearbyAreas.length" :destination-slug="webcam.nearbyAreas[0].area.slug" destination-type="area")
		h2.mt-6 {{$t('page.webcams.webcam:webcams.nearby')}}
		area-webcam-list(:items="webcam.nearbyWebcams")
		div.text-center.my-6
			v-btn(color="primary" outlined :to="localePath({name:'weather-webcams'})") {{$t('page.webcams.webcam:all.webcams.button')}}
		h2.mt-6 {{$t('page.webcams.webcam:areas.nearby')}}
		v-simple-table
			template(#default)
				thead
					tr
						th {{$t('page.webcams._webcam.areas:area')}}
						th.text-right {{$t('page.webcams._webcam.areas:distance')}}
				tbody
					template(v-for="area in webcam.nearbyAreas")
						tr
							td
								img.flag.mr-2(:src="`https://static.wintersport.nl/images/flags/svg/${area.area.country.countryCode}.svg`" :alt="area.area.country.name")
								nuxt-link(:to="localePath({name:'areas-area', params: {area: area.area.slug}})") {{area.area.name}}
							td.text-right.grey--text
								span(v-if="area.distance && webcam.nearbyAreas[0].area.slug !== area.area.slug") {{area.distance}}km
</template>

<script>
import gql from 'graphql-tag';
import Navigation from '@/components/navigation';
import MetaFragment from '@/components/graphql/metaFragment.graphql';
import AreaWebcamList from '@/components/areas/webcam-list.vue';
import Travelbox from '@/components/travelbox.vue';
import { interpolateFields } from '@/utils/interpolate.js';

const query = gql`
	query weatherWebcamQuery($path: String, $webcamId: Int!) {
		contentpage(path: $path) {
			id
			name
			slug
			content {
				markdown
			}
			...MetaFragment
		}
		webcam(id: $webcamId) {
			id
			name
			elevation
			preview
			url
			nearbyWebcams {
				id
				name
				elevation
				preview
			}
			nearbyAreas(limit: 6) {
				distance
				area {
					id
					name
					slug
					country {
						id
						name
						countryCode
					}
				}
			}
		}
	}
	${MetaFragment}
`;

export default {
	name: 'WeatherWebcamsWebcam',
	nuxtI18n: {
		paths: {
			'nl-NL': '/webcams/:webcam',
			'de-DE': '/wetter-schnee/webcams/webcam/:webcam',
			'nl-BE': '/webcams/:webcam'
		}
	},
	components: { Navigation, AreaWebcamList, Travelbox },
	layout: 'default',
	asyncData({ params, app, route }) {
		if (!parseInt(params.webcam)) {
			return app.httpError(404, null, 'webcams-webcam-03');
		}

		return app.$graphClient
			.query({
				query,
				variables: {
					path: route.path.replace(params.webcam, '_webcam'),
					webcamId: parseInt(params.webcam)
				},
				errorPolicy: 'all',
				fetchPolicy: 'network-only'
			})
			.then(({ data, errors }) => {
				// if (!data.contentpage || !data.webcam || !data.webcam.embeds.length) {
				// 	return app.httpError(404, null, 'webcams-webcam-01', errors);
				// }
				if (errors) {
					throw errors[0];
				}

				const interPolateFunction = interpolateFields({
					find: /{(webcam|elevation)}/gi,
					replace: (match, group) => {
						return {
							webcam: data.webcam.name,
							elevation: data.webcam.elevation
						}[group];
					}
				});

				interPolateFunction(data.contentpage.meta, ['title', 'description']);
				interPolateFunction(data.contentpage, ['name']);

				app.meta(data.contentpage.meta);
				app.ads({
					sidebar: { visible: true },
					navigation: { visible: true, type: 'spot' }
				});
				app.breadcrumbs({
					[app.i18n.t(`page.webcams:breadcrumb`)]: {
						name: 'weather-webcams'
					},
					[data.webcam.name]: {
						name: 'webcams-webcam',
						params: { webcam: params.webcam }
					}
				});

				return data;
			})
			.catch(app.$destinationNotFoundCatcher)
			.catch(error => {
				return app.httpError(500, null, 'webcams-webcam-02', error);
			});
	},
	head() {
		return {
			...this.$structuredData()
		};
	},
	computed: {
		// webcamEmbed() {
		// 	const embeds = this.webcam.embeds.filter(embed => embed.available);
		// 	return embeds.length ? embeds[0].embed : null;
		// }
	}
};
</script>
